<!-- display-mobile-23 preview — a full-screen interstitial, and placement 7's
     card drawn over a blurred ground: the creative runs from the top of the
     screen down to a white card that carries the advertiser mark, the headline,
     the description and a dismiss / action pair. The creative blurred out sits
     behind everything, so it shows only in the margin the card leaves around
     itself. Nothing here is shared with the in-article placements, which are
     all slots on a publisher page — this one replaces the page. -->
<app-mobile-frame>
  <!-- START: Interstitial -->
  <div class="da-unit">
    <!-- The creative again, blurred past recognition and cropped to cover: it is
         the unit's ground, and all the mock ever shows of it is the strip either
         side of the card and the band under it. Decorative on purpose — the
         creative itself is a link of its own below. -->
    <img *ngIf="creativeImage" class="da-backdrop" [src]="creativeImage" alt="" aria-hidden="true" />

    <!-- The picture. It takes the whole screen above the card, which is what the
         mock draws; the "Otok Rab" pill and the resort name over it there are
         part of the uploaded creative, not ad chrome, so nothing here draws
         them. -->
    <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-creative">
      <img *ngIf="creativeImage" class="da-creative-image" [src]="creativeImage" alt="" />
      <div *ngIf="!creativeImage" class="da-creative-image creative-missing">{{ missingDimensionLabel }}</div>
    </a>

    <!-- Chrome the network draws over the unit, so it is decorative here. -->
    <span
      class="da-adchoices d-flex align-items-center justify-content-center"
      aria-hidden="true"
    >
      <i class="bi bi-info-circle"></i>
    </span>

    <!-- START: The copy card -->
    <div class="da-card">
      <img *ngIf="data.logo" class="da-logo" [src]="data.logo" alt="" />
      <span *ngIf="!data.logo" class="da-logo logo-empty" aria-hidden="true"></span>

      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
        {{ data.headlines[0] || "Your headline appears here" }}
      </a>

      <div class="da-desc">
        {{ data.descriptions[0] || "Your description appears here" }}
      </div>

      <div class="da-actions d-flex flex-row">
        <!-- The interstitial's dismiss control. It is ad chrome rather than
             authored copy, so it is a literal — there is no field for it on the
             template. The mock is a Croatian preview and reads "Zatvori" there;
             it stays English here like the other placements, since the network
             localises its own chrome at serve time. -->
        <span class="da-close d-flex align-items-center justify-content-center">
          <span class="da-label">Close</span>
        </span>

        <a
          [href]="data.url" target="_blank" rel="noopener noreferrer"
          class="da-cta d-flex align-items-center justify-content-center"
        >
          <span class="da-label">{{ data.ctaText || "Your call to action" }}</span>
        </a>
      </div>
    </div>
    <!-- END: The copy card -->
  </div>
  <!-- END: Interstitial -->
</app-mobile-frame>
